// extracted by css-extract-rspack-plugin
export default {"cls1":"LearningPoints-cls1_s9S","cls2":"LearningPoints-cls2_2Am LearningPoints-cls1_s9S"};